module.exports = __webpack_public_path__ + "static/media/9.3f90b8a5.gif";